export const cookieSettings = {
    cookiename: "cookiesettings",
    cookieLifeTime: 1, // in months
};

export const cookieNoticeSettings = {
    centerMode: true,
    ignoredPages: [
        '/datenschutz',
    ],
    hasDeclineButton: false,
    // backgroundColor: 'blue',
    // textColor: 'red',
    useBackdrop: true,
    backdropColor: '#333',
    backdropOpacity: '0.8',
    autoEnableMandatory: false,
    autoEnableMandatoryOnPlaceholder: true,
};

export const cookieNoticeTexts = {
    "de": {
        initialHeadline: 'Cookies',
        customizeHeadline: 'Ihre Datenschutz-Einstellungen',
        // explanationText: "Nach Ihrer Zustimmung verwenden wir Cookies um die Anzeige zu optimieren. Zur Analyse der Zugriffe auf unsere Website verwenden wir [[ Google Analytics / Matomo Analytics ]]. Außerdem binden wir Skripte von [[ YouTube, Vimeo, Google Maps, Mapbox, Facebook, Twitter, Instagram, ...]] ein. Dabei können personenbezogene Daten an diese Anbieter übermittelt werden. Bitte klicken Sie <a href='/datenschutz'>hier</a>, um Informationen zum Datenschutz zu erhalten.",
        explanationText: "<div>Für die Funktionalität der Buchungsseite müssen sog. Session-Cookies gesetzt werden. Dies speichern keine personenbezogenen Daten. Bitte klicken Sie <a href='https://www.deutsche-eiche.de/service/datenschutz/' target='_blank'>hier</a>, um Informationen zum Datenschutz zu erhalten.</p><p>For the functioning of the booking site, so-called session cookies must be employed. These do not store any personal data. Please click <a href='https://www.deutsche-eiche.de/en/service/privacy/' target='_blank'>here</a> for more information on our data protection policy.</p>",
        accept_preset_ButtonText: 'OK',
        declineButtonText: 'Ablehnen und schließen',
        accept_all_ButtonText: 'Alle Cookies Akzeptieren',
        decline_all_ButtonText: 'Alle Ablehnen',
        customizeButtonText: 'Einstellungen',
        cancel_customizeButtonText: 'Abbrechen',
        saveButtonText: 'Speichern',
        closeButtonText: '×'
    },
    "en": {
        initialHeadline: 'Cookies',
        customizeHeadline: 'Select cookies to accept',
        explanationText: "<div>For the functioning of the booking site, so-called session cookies must be employed. These do not store any personal data. Please click here <a href='https://www.deutsche-eiche.de/en/service/privacy/' target='_blank'>here</a>",
        accept_preset_ButtonText: 'Accept and proceed',
        declineButtonText: 'Decline and close',
        accept_all_ButtonText: 'Accept all',
        decline_all_ButtonText: 'Decline all',
        customizeButtonText: 'Customize',
        cancel_customizeButtonText: 'Cancel',
        saveButtonText: 'Save',
        closeButtonText: '×'
    }
};

export const cookieSets = {
    "de": [
        {
            id: 'mandatory',
            name: 'Notwendige Cookies',
            description: 'Diese Cookies sind für die einwandfreie Funktion und das Design unserer Seiten nötig. Sie speichern keine personenbezogenen Daten.',
            mandatory: true,
            mandatory_text: "Diese Cookies sind notwendig, um Ihre Einstellungen zu speichern."
        }
        ],
    "en": [
        {
            id: 'mandatory',
            name: 'Mandatory cookies',
            description: 'These cookies are necessary to ensure the correct function of the booking website.',
            mandatory: true,
            mandatory_text: "Dies muss gemacht werden."
        }]
};
